import { mainApi } from '../utils/api';

import { type BaseInput, type ByIdInput } from './models';

export type GetReceivedModelsInput = BaseInput;

export type GetReceivedModelByIdInput = ByIdInput;

export type GetReceivedModelOutputInput = ByIdInput;

export type ImportReceivedModelInput = ByIdInput;

const getReceivedModelOutput = ({
  modelId,
  orgId,
  projectId,
}: GetReceivedModelOutputInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/received_models/${modelId}/output/`
  );

const importReceivedModel = ({
  modelId,
  orgId,
  projectId,
}: ImportReceivedModelInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/received_models/${modelId}/clone/`
  );

const getReceivedModelById = ({
  orgId,
  projectId,
  modelId,
}: GetReceivedModelByIdInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/received_models/${modelId}/`
  );

const getReceivedModels = ({ orgId, projectId }: GetReceivedModelsInput) =>
  mainApi.get(`organizations/${orgId}/projects/${projectId}/received_models/`);

export {
  getReceivedModels,
  getReceivedModelById,
  getReceivedModelOutput,
  importReceivedModel,
};
